import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-ongoing-warning",
    templateUrl: "./ongoing-warning.component.html",
    styleUrls: ["./ongoing-warning.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class OngoingWarningComponent implements OnInit {
  selectedId: number = null;
  constructor(
    private matDialogRef: MatDialogRef<OngoingWarningComponent>,
    private GTMSegment: GTMSegmentService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.GTMSegment.GTMPopupInitialization("DeclineInvitaion");
  }

  ngOnInit() {}

  onReveal(selectedId: number) {
    this.selectedId = selectedId;
  }

  leaveSyndicate() {
    this.GTMSegment.HotJarEvent('syndicate_switch_off');
    this.matDialogRef.close(true);
  }

  close() {
    this.matDialogRef.close();
  }
}
